@if (true) {
<div class="container-fluid">
    <div class="page-heading d-flex align-items-center justify-content-between my-4 px-2">
        {{pageHeader}}
        <button class="btn btn-outline-primary" title="Go Back" (click)="goBack()">
            <i class="fa fa-arrow-left"></i> Back
        </button>
    </div>
    <form [formGroup]="addFormContact" (ngSubmit)="onClickSubmit(addFormContact.value)">
        <div class="card rounded-4 border-0">
            <div class="card-body">
                <div class="row">

                    <!-- Contact Name -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>
                                {{ contactName }} <span class="text-danger">*</span>
                            </label>
                            <input type="text" class="form-control" formControlName="contactName"
                                placeholder="Enter Name"/>
                            @if(f.contactName.touched && f.contactName.invalid) {
                                @if (f.contactName.errors?.required) {
                                    <div class="text-danger">
                                        {{ contactName }} is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Map Organization -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>{{ mapOrganization }} </label>
                            <ng-select [items]="ContactOrgList" [multiple]="true" bindLabel="Name" bindValue="ID"
                                formControlName="MapContactOrg"
                                placeholder="Select Organization">
                                <ng-template
                                ng-option-tmp
                                let-item="item"
                                let-item$="item$"
                                let-index="index"
                                >
                                {{ item.Name }}

                                @if (item.State || item.City) {
                                    (
                                    {{ item.State }}
                                    @if (item.State && item.City) {, }
                                    {{ item.City }}
                                    )
                                }

                                @if (item.Mobile) {
                                    ({{ item.Mobile }})
                                }
                                </ng-template>

                            </ng-select>
                            @if (f.MapContactOrg.touched && f.MapContactOrg.invalid) {
                                @if (f.MapContactOrg.errors?.required) {
                                    <div class="text-danger">
                                        Organization is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Company -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label><a [href]="RouteCompany" target="_blank">Company</a> <span class="text-danger">*</span> </label>
                            <ng-select [items]="Company" bindLabel="Name" bindValue="ID" formControlName="Company"
                                placeholder="Select Company" />
                            @if (f.Company.touched && f.Company.invalid) {
                                @if (f.Company.errors?.required) {
                                    <div class="text-danger">
                                        Company is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Internal Department -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label><a [href]="RouteGMDepartment" target="_blank">Internal Department</a> <span class="text-danger">*</span> </label>
                            <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="Department" placeholder="Select Department" />
                            @if (f.Department.touched && f.Department.invalid) {
                                @if (f.Department.errors?.required) {
                                    <div class="text-danger">
                                        Internal Department is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Designation -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label><a [href]="RouteGMDesignation" target="_blank">Designation</a> <span class="text-danger">*</span> </label>
                            <ng-select [items]="Designation" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="Designation" placeholder="Select Designation" />
                            @if (f.Designation.touched && f.Designation.invalid) {
                                @if (f.Designation.errors?.required) {
                                    <div class="text-danger">
                                        Designation is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Department -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label><a [href]="RouteGMDepartment" target="_blank">Department</a></label>
                            <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID"
                                formControlName="Departmentd" placeholder="Select Department" />
                            @if (f.Departmentd.touched && f.Departmentd.invalid) {
                                @if (f.Departmentd.errors?.required) {
                                    <div class="text-danger">
                                        Department is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Address -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Address <span class="text-danger">*</span> </label>
                            <textarea class="form-control" rows="2" formControlName="address"
                                placeholder="Enter Address"></textarea>
                            @if (f.address.touched && f.address.invalid) {
                                @if (f.address.errors?.required) {
                                    <div class="text-danger">
                                        Address is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Company Code -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>{{ companyCode }} <span class="text-danger">*</span> </label>
                            <input type="text" class="form-control" formControlName="companycode"
                                [placeholder]="companyCode" />
                            @if (f.companycode.touched && f.companycode.invalid) {
                                @if (f.companycode.errors?.required) {
                                    <div class="text-danger">
                                        {{ companyCode }} is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Agency -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label><a [href]="RouteGMAgency" target="_blank">Agency</a> <span class="text-danger">*</span> </label>
                            <ng-select [items]="Agency" bindLabel="MainDescr" bindValue="hdID" formControlName="Agency"
                                placeholder="Select Agency" />
                            @if (f.Agency.touched && f.Agency.invalid) {
                                @if (f.Agency.errors?.required) {
                                    <div class="text-danger">
                                        Agency is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Mobile -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Mobile <span class="text-danger">*</span> </label>
                            <input type="number" class="form-control" formControlName="MobileNumber"
                                placeholder="Enter Mobile No" />
                            @if (f.MobileNumber.touched && f.MobileNumber.invalid) {
                                @if (f.MobileNumber.errors?.required) {
                                    <div class="text-danger">
                                        Mobile is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- State -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label><a [href]="RouteGMState" target="_blank">State</a> <span class="text-danger">*</span> </label>
                            <ng-select [items]="State" bindLabel="MainDescr" bindValue="hdID" formControlName="State"
                                (change)="onStateSelect($event)" placeholder="Select State" />
                            @if (f.State.touched && f.State.invalid) {
                                @if (f.State.errors?.required) {
                                    <div class="text-danger">
                                        State is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Work Phone -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Work Phone</label>
                            <input type="text" class="form-control" formControlName="workphone"
                                placeholder="Work Phone" />
                        </div>
                    </div>

                    <!-- City -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label><a [href]="RouteGMCity" target="_blank">City</a></label>
                            <ng-select [items]="City" bindLabel="MainDescr" bindValue="hdID" formControlName="City"
                                (change)="onCitySelect($event)" placeholder="Select City" />
                            @if (f.City.touched && f.City.invalid) {
                                @if (f.City.errors?.required) {
                                    <div class="text-danger">
                                        City is Required
                                    </div>
                                }
                            }
                        </div>
                    </div>

                    <!-- Work Phone 1 -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Work Phone 1</label>
                            <input type="text" class="form-control" formControlName="workphone2"
                                placeholder="Enter Work Phone 1" />
                        </div>
                    </div>

                    <!-- Court -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label><a [href]="RouteGMJurisdiction" target="_blank">Court</a></label>
                            <ng-select [items]="Court" bindLabel="MainDescr" bindValue="hdID" formControlName="Court"
                                placeholder="Select Court" />
                        </div>
                    </div>

                    <!-- Fax -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Work Fax</label>
                            <input type="text" class="form-control" formControlName="faxno"
                                placeholder="Enter Fax No" />
                        </div>
                    </div>

                    <!-- Zip -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Zip / Postal Code</label>
                            <input type="text" class="form-control" formControlName="zipcode"
                                placeholder="Enter Zip Code" />
                        </div>
                    </div>

                    <!-- Web Page -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Web Page</label>
                            <input type="text" class="form-control" formControlName="webPage"
                                placeholder="Enter Web Page" />
                        </div>
                    </div>

                    <!-- Email -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" class="form-control" formControlName="email1"
                                placeholder="Enter Email" />
                        </div>
                    </div>

                    <!-- Email 1 -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Email 1</label>
                            <input type="email" class="form-control" formControlName="email2"
                                placeholder="Enter Email (Optional)" />
                        </div>
                    </div>

                    <!-- Contact Type -->
                    <div class="col-12 col-md-4">
                        <div class="form-group">
                            <label>Contact Type</label>
                            <ng-select [items]="ContactType" bindLabel="SubDescr" bindValue="SubID"
                                formControlName="ContactType" [clearable]="false"  placeholder="Select Contact Type" />
                        </div>
                    </div>

                </div>

            </div>
        </div>
        <!-- Submit Button -->
        @if (
        RightsID.includes('202034001') ||
        RightsID.includes('202034021')
        ) {
        <div class="d-flex justify-content-center mt-4">
            <button type="submit" class="btn btn-primary submit-btn" [disabled]="disableButton">
                {{ buttonname }}
            </button>
        </div>
        }
    </form>
</div>
}@else {
<!-- <my-content placeholder="navigation">

    <div class="col-sm-12 divbordergry "></div>
    <div class=" col-sm-12">

        <div class=" col-sm-12 lefticonD paddingless"><label>{{pageHeader}}</label>
        </div>
        <div>&nbsp;</div>
        <form #createContact="ngForm" [formGroup]="addFormContact"
            (ngSubmit)="onClickSubmit(createContact.value); disabled=true;">
            <fieldset>
                <table width="100%">
                    <tr>
                        <td width="15%">{{contactName}}</td>
                        <td width="35%">

                            <div class="col-sm-10"><input type="text" formControlName="contactName" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f.contactName.errors }"
                                    placeholder="Enter Name" required="required" /> </div>
                            <div *ngIf="submitted && f.contactName.errors" class="invalid-feedback">
                                <div *ngIf="f.contactName.errors.required"> required</div>
                            </div>
                        </td>
                        <td width="15%">{{mapOrganization}}</td>
                        <td width="35%">
                            <div class="col-sm-10">
                                <ng-select [items]="ContactOrgList" [multiple]="true" formControlName="MapContactOrg"
                                    bindLabel="Name" [selectableGroup]="true" [closeOnSelect]="true" bindValue="ID"
                                    [(ngModel)]="selectedContactOrg">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        {{item.Name}}&nbsp;&nbsp;&nbsp;({{item.State}},{{item.City}})&nbsp;&nbsp;&nbsp;({{item.Mobile}})
                                    </ng-template>
                                </ng-select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="{{RouteCompany}}" target="_blank">Company</a></td>
                        <td>
                            <div class="col-sm-10">
                                <ng-select [items]="Company" bindLabel="Name" bindValue="ID" formControlName="Company"
                                    [clearable]="false" placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                        <td><a href="{{RouteGMDepartment}}" target="_blank">Internal Department</a></td>
                        <td>
                            <div class="col-sm-10">
                                <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID"
                                    formControlName="Department" [clearable]="false" placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="{{RouteGMDesignation}}" target="_blank">Designation</a></td>
                        <td>
                            <div class="col-sm-10">
                                <ng-select [items]="Designation" bindLabel="MainDescr" bindValue="hdID"
                                    formControlName="Designation" [clearable]="false" placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                        <td><a href="{{RouteGMDepartment}}" target="_blank">Department</a></td>
                        <td>
                            <div class="col-sm-10">
                                <ng-select [items]="Department" bindLabel="MainDescr" bindValue="hdID"
                                    formControlName="Departmentd" [clearable]="false" placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Address</td>
                        <td>
                            <div class="col-sm-10"> <textarea class="form-control" formControlName="address" rows="1"
                                    placeholder="Address"></textarea>
                            </div>
                        </td>
                        <td>{{companyCode}}</td>
                        <td>
                            <div class="col-sm-10"><input class="form-control " placeholder={{companyCode}}
                                    formControlName="companycode" type="text"></div>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="{{RouteGMAgency}}" target="_blank">Agency</a></td>
                        <td>
                            <div class="col-sm-10">
                                <ng-select [items]="Agency" bindLabel="MainDescr" bindValue="hdID"
                                    formControlName="Agency" [clearable]="false" placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                        <td>Mobile</td>
                        <td>
                            <div class="col-sm-10"><input class="form-control" placeholder="Enter Mobile No"
                                    formControlName="MobileNumber" type="text"></div>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="{{RouteGMState}}" target="_blank">State</a></td>
                        <td>
                            <div class="col-sm-10">
                                <ng-select [items]="State" bindLabel="MainDescr" bindValue="hdID"
                                    formControlName="State" (change)="onStateSelect($event)" [clearable]="false"
                                    placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                        <td>Work Phone</td>
                        <td>
                            <div class="col-sm-10"><input class="form-control" placeholder="Work Phone"
                                    formControlName="workphone" type="text"></div>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="{{RouteGMCity}}" target="_blank">City</a></td>
                        <td>
                            <div class="col-sm-10">
                                <ng-select [items]="City" bindLabel="MainDescr" bindValue="hdID" formControlName="City"
                                    (change)="onCitySelect($event)" [clearable]="false" placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                        <td>Work Phone 1</td>
                        <td>
                            <div class="col-sm-10"><input class="form-control" placeholder="Enter work phone 1"
                                    formControlName="workphone2" type="text"></div>
                        </td>
                    </tr>
                    <tr>
                        <td><a href="{{RouteGMJurisdiction}}" target="_blank">Court</a></td>
                        <td>
                            <div class="col-sm-10">
                                <ng-select [items]="Court" bindLabel="MainDescr" bindValue="hdID"
                                    formControlName="Court" [clearable]="false" placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                        <td>Work Fax</td>
                        <td>
                            <div class="col-sm-10"><input class="form-control " placeholder="Enter Fax No"
                                    formControlName="faxno" type="text"></div>
                        </td>
                    </tr>
                    <tr>
                        <td>Zip/Postal Code</td>
                        <td>
                            <div class="col-sm-10"><input class="form-control " placeholder="Enter Zip/Postal Code"
                                    formControlName="zipcode" type="text"></div>
                        </td>
                        <td>Web Page</td>
                        <td>
                            <div class="col-sm-10"><input class="form-control " placeholder="Enter Web Page"
                                    formControlName="webPage" type="text"></div>
                        </td>
                    </tr>
                    <tr>
                        <td>Email</td>
                        <td>
                            <div class="col-sm-10"><input class="form-control " placeholder="Enter Email"
                                    formControlName="email1" type="email"></div>
                        </td>
                        <td>Email 1</td>
                        <td>
                            <div class="col-sm-10"><input class="form-control "
                                    placeholder="Enter Email1 (if available)" formControlName="email2" type="email">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Contact Type</td>
                        <td>
                            <div class="col-sm-10">
                                <ng-select [items]="ContactType" bindLabel="SubDescr" bindValue="SubID"
                                    formControlName="ContactType" [clearable]="false" placeholder="Not Selected">
                                    <ng-option [value]="'0'">Not Selected</ng-option>
                                </ng-select>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td colsp="1">&nbsp;</td>
                        <td colsp="1">&nbsp;</td>
                        <td colsp="1"><br>
                            <div class="form-group col-sm-4"
                                *ngIf="this.RightsID.includes('202034001') || this.RightsID.includes('202034021') ; then AddContactLink else AddContactNoLink">
                            </div>
                            <ng-template #AddContactLink>
                                <input class="btn btn-primary col-sm-12" [disabled]="disableButton" type="submit"
                                    name="abc" value="{{buttonname}}" ngmodel>
                            </ng-template>
                            <ng-template #AddContactNoLink>
                                &nbsp;
                            </ng-template>

                        </td>

                    </tr>
                </table>
            </fieldset>
        </form>
        <div>&nbsp;<br>&nbsp;&nbsp;<br></div>


    </div>


    <div>&nbsp;&nbsp;</div>
    <div class="form-group mt-2" style="display:none;">
        <div class="form-check">
            <input type="checkbox" name="autoClose" id="autoClose" class="form-check-input" checked=true
                [(ngModel)]="options.autoClose">
            <label for="autoClose">Auto close alert after three seconds</label>
        </div>

    </div>
    <div class="jumbotron p-4">
        <div class="container text-center col-sm-3 alertCss">
            <app-alert></app-alert>
            <router-outlet></router-outlet>
        </div>
    </div>
</my-content>
<my-content placeholder="main">

</my-content> -->
}